module.exports = __webpack_public_path__ + "img/ecs-arrow.461671f7.png";